var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBattery75PercentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2H7.5V0H2.5V2H1.5C0.675 2 0 2.675 0 3.5V18.5C0 19.325 0.675 20 1.5 20H8.5C9.325 20 10 19.325 10 18.5V3.5C10 2.675 9.325 2 8.5 2ZM9 18.5C9 18.775 8.775 19 8.5 19H1.5C1.225 19 1 18.775 1 18.5V3.5C1 3.225 1.225 3 1.5 3H8.5C8.775 3 9 3.225 9 3.5V18.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5V17.5C8 17.775 7.775 18 7.5 18H2.5C2.225 18 2 17.775 2 17.5V7.5H8Z",
    fill: "#4AAD40"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBattery75PercentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Battery75_percent_icon.9a9ce110990ae2724715910575e85e3e.svg";